/* eslint-disable global-require */
/* eslint-disable import/prefer-default-export */
import Web3 from 'web3';
import { create } from 'ipfs-http-client';
import { ENVIRONMENT } from 'configs';
import NFTContract from 'configs/abis/NFTMarketplace.json';
import toast from 'react-hot-toast';

let client;

window.Buffer = window.Buffer || require('buffer').Buffer;

const auth = `Basic ${Buffer.from(
  `${ENVIRONMENT.PROJECT_ID}:${ENVIRONMENT.PROJECT_SECRET}`
).toString('base64')}`;

try {
  client = create({
    url: 'https://ipfs.infura.io:5001/api/v0',
    headers: {
      authorization: auth,
    },
  });
} catch (error) {
  client = undefined;
  console.error('IPFS error ', error);
}

const web3 = new Web3(
  Web3.givenProvider || 'ws://some.local-or-remote.node:8546'
);

export const addAdmin = async (data) => {
  const account = await web3.eth.getAccounts();
  if (account.length !== 0) {
    const contract = new web3.eth.Contract(
      NFTContract.abi,
      ENVIRONMENT.CONTRACT_ADDRESS
    );
    const address = await web3.eth.getAccounts();
    const tokenURI = JSON.stringify({
      name: data.name,
      wallet: data.wallet,
      email: data.email,
      image: data.image,
    });
    const added = await client?.add(tokenURI);

    const res = await contract.methods
      .addAdmin(added?.path, data.wallet)
      .send({ from: address[0] });
    // .send({ from: address[0], value: Web3.utils.toWei("0.0025", "ether") });
    return res;
  }
  return toast('Connect your wallet before add an admin.', {
    position: 'bottom-center',
    icon: '⚠️',
  });
};
